import { Typography } from "@mui/material";

const CustomImage = ({
  labelVariant,
  labelStyle,
  url,
  title,
  altText,
  height = "200px",
  width = "200px",
  maxWidth = "200px",
  maxHeight = "100%",
}) => {
  return (
    <>
      {title && (
        <Typography
          variant={labelVariant ? labelVariant : "h6"}
          sx={labelStyle}
        >
          {title}
        </Typography>
      )}
      <img
        src={url}
        alt={altText}
        height={height}
        width={width}
        style={{ maxWidth, maxHeight, width: "100%", height: "auto" }}
      />
    </>
  );
};

export default CustomImage;
